export const filteredReportingUnitsByBrand =
  (brand: string, filter: string) => state => {
    let units = state.ReportingUnitsReducer?.reportingUnitsByBrand?.[brand];
    if (units) {
      filter = (filter || '').toLowerCase();
      units =
        filter.length >= 3
          ? units.filter(unit => unit.name.toLowerCase().includes(filter))
          : [];
    }
    return units;
  };

export const getReportingUnitsByBrand = (brand: string) => state => {
  const obj = state.ReportingUnitsReducer?.reportingUnitsByBrand?.[brand];
  return obj
    ? Object.entries<any>(obj).map(([id, item]) => ({
        ...item,
        test: 'test',
        id,
      }))
    : undefined;
};

export const getReportingUnitById =
  (brand: string, reportUnitId: any) => state => {
    let item;
    const reportingUnitState = state.ReportingUnitsReducer || {};
    const reportUnit =
      reportingUnitState.reportingUnitsByBrand?.[brand]?.[reportUnitId];
    if (brand && reportUnitId) {
      item = {
        id: reportUnitId,
        ...reportUnit,
        groups: reportUnit.groups
          ?.map(
            groupId =>
              reportingUnitState.franchiseGroupsById?.[brand]?.[groupId],
          )
          .filter(group => !!group),
      };
    }
    return item;
  };

export const getFranchiseGroups = (brand: string) => state => {
  const reportingUnitState = state.ReportingUnitsReducer || {};
  return reportingUnitState.franchiseGroupsById?.[brand] || {};
};
